export default {
  ENGLISH_US: 'en-US',
  SPANISH_ES: 'es-ES',
  SPANISH_LATAM: 'es-419',
  PORTUGUESE_BR: 'pt-BR',
  PORTUGUESE_PT: 'pt-PT',
  FRENCH_FR: 'fr-FR',
  RUSSIAN_RU: 'ru-RU',
  GERMAN_DE: 'de-DE',
  HINDI_IN: 'hi-IN',
  TURKISH_TR: 'tr-TR',
  AZERBAIJANI_AZ: 'az-AZ',
  ROMANIAN_RO: 'ro-RO',
  UKRAINIAN: 'uk-UA',
  ITALIAN_IT: 'it-IT'
} as const;
